import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

import { AdminTopbar } from "@/components/admin/AdminTopbar";
import { AdminCard } from "@/components/admin/primitives";
import { CampaignDetail } from "@/components/campanhas/CampaignDetail";
import { searchToQuery, validateCampaignSearch } from "@/lib/campaigns";
import { presetPeriod } from "@/lib/reports";
import { useSession } from "@/lib/session";

/**
 * Uma campanha de revendedor, no painel.
 *
 * Fora da árvore de `relatorios` (o `_` no nome) para não depender do layout
 * das abas — é uma página inteira, com volta para a aba de revendedores.
 */
export const Route = createFileRoute("/admin/_painel/relatorios_/campanhas/$campanhaId")({
  validateSearch: validateCampaignSearch,
  head: () => ({ meta: [{ title: "Campanha — Painel MonteBox" }] }),
  component: AdminCampaign,
});

function AdminCampaign() {
  const { profile } = useSession();
  const { campanhaId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const { from, to } = searchToQuery(search, presetPeriod("mes"));

  if (profile && profile.role !== "ADMIN") {
    return (
      <>
        <AdminTopbar title="Campanha" />
        <AdminCard className="m-8 p-8 text-center text-sm text-mb-muted">
          Relatórios têm custo e lucro da empresa — só administradores acessam.
        </AdminCard>
      </>
    );
  }

  return (
    <>
      <AdminTopbar title="Campanha" />
      <div className="flex flex-col gap-4 p-4 sm:p-8">
        <Link
          to="/admin/relatorios"
          search={{ aba: "revendedores", de: from, ate: to }}
          className="flex w-fit items-center gap-1.5 text-sm font-semibold text-mb-muted hover:text-mb-navy"
        >
          <ArrowLeft className="h-4 w-4" />
          Revendedores
        </Link>
        <CampaignDetail
          side="admin"
          campaignId={campanhaId}
          period={{ from, to }}
          onPeriodChange={(next) => void navigate({ search: { de: next.from, ate: next.to } })}
        />
      </div>
    </>
  );
}
